import React from 'react';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import Tooltip from '../utility/Tooltip';
import './SaveExitButton.scss';

const SaveExitButton = ({
  isMobile,
  isTimed = false,
  onShowModal,
  showTooltip = true,
  isDummyPlayer = false,
}) => {
  const onSaveExit = (event) => {
    if (isDummyPlayer) {
      onShowModal('DummyExit');
    } else {
      const initiatorElement = event.currentTarget;
      onShowModal('ExitConfirmation', { initiatorElement });
    }
  };

  const button = (
    <ButtonWithIcon
      isNaked
      tabIndex="0"
      icon="close"
      iconOrientation="right"
      iconWidth="15"
      iconHeight="15"
      aria-label={
        isTimed ? 'Save and Exit timed popup' : 'Save and Exit untimed popup'
      }
      onClick={onSaveExit}
      className="SaveExitButton desktop:mr-6"
      data-tip
      data-for="saveExit"
    >
      {isMobile && 'Save & Exit'}
    </ButtonWithIcon>
  );

  return isMobile || !showTooltip ? (
    button
  ) : (
    <Tooltip target="saveExit" description="Save and Exit" position="bottom">
      {button}
    </Tooltip>
  );
};

export default SaveExitButton;
